module.exports = __webpack_public_path__ + "img/US.5df840c2.jpg";